module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<input id="'+
((__t=( inputId ))==null?'':__t)+
'" class="'+
((__t=( classes.join(' ') ))==null?'':__t)+
'"/>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/common/remote-suggester-input.html
// module id = 200
// module chunks = 0